<!--
 * @Author: yannis yannis2473@163.com
 * @Date: 2025-04-14 15:20:21
 * @LastEditors: yannis yannis2473@163.com
 * @LastEditTime: 2025-07-18 10:53:38
 * @FilePath: \crm-admin-vue\src\views\layout\components\AppMain.vue
 * @Description: Do not edit
 * Copyright (c) 2025 by 久雀商业/Yannis, All Rights Reserved. 
-->
<template>
  <div class="app-main">
    <keep-alive include="biAreaStatisticClue,biChannelStatisticClue">
      <router-view />
    </keep-alive>
    <slot />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'AppMain',
  methods: {
    ...mapMutations(['SET_COLLAPSE'])
  },
  mounted() {},
  computed: {}
};
</script>

<style scoped>
@media screen and (max-width: 768px) {
  .app-main {
    width: 100%;
    box-sizing: border-box;
    padding-left: 2.6667vw;
    padding-right: 2.6667vw;
    overflow-y: scroll !important;
  }
}
.app-main {
  position: relative;
  height: 100%;
}
</style>
